import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import AddressFieldset from "../AddressFieldset";
import { IAddress } from "../../types/seed";
import { getBestAddress } from "../../utils/addressUtils";

interface AddressDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (address_obj?: IAddress | null) => void;
  defaultAddress: string;
  defaultAddressObj?: IAddress | null;
}

const AddressDialog: React.FC<AddressDialogProps> = ({
  open,
  onClose,
  onSave,
  defaultAddress,
  defaultAddressObj,
}) => {
  const [addressObj, setAddressObj] = useState<IAddress | null>(null);

  const handleSave = () => {
    onSave(addressObj);
  };

  const handleUseDefault = () => {
    onSave(defaultAddressObj);
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Endereço</DialogTitle>
      <DialogContent>
        <AddressFieldset address={addressObj} onChange={setAddressObj} />
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Ou, se preferir, use seu endereço já cadastrado:
          </Typography>
          <Box
            onClick={handleUseDefault}
            sx={{
              color: "primary.main",
              cursor: "pointer",
              textDecoration: "underline",
              p: 1,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              backgroundColor: "#fafafa",
            }}
          >
            {getBestAddress(defaultAddressObj, defaultAddress)}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button disabled={!addressObj} onClick={handleSave}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddressDialog;
